(function(cookie, domain) {
  var params = {};
  window.location.search.substring(1).split("&").forEach(function(chunk) { const pair = chunk.split("="); params[pair[0]] = pair[1] });

  if (typeof(params["affiliate"]) !== "undefined") {
    var expires = new Date();
    expires.setTime(expires.getTime() + 7776000000); //1000*60*60*24*90 (90 days)
    document.cookie = cookie + "=" + params["affiliate"] + "; expires=" + expires.toGMTString() + "; domain=" + domain + "; path=/";
  }
})("affiliate", ".honeybadger.io");
